<svg
  width="25"
  height="26"
  viewBox="0 0 25 26"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_148_5539)">
    <path
      d="M7.45914 10.6545C7.70864 9.52406 7.8334 8.95885 8.266 8.74684C8.69859 8.53484 9.22173 8.78254 10.268 9.27795L12.9938 10.5686C13.6404 10.8747 13.9637 11.0278 14.288 10.9633C14.6123 10.8987 14.8523 10.6335 15.3324 10.1031L15.6104 9.79597C17.6418 7.55172 18.6574 6.42959 19.3411 6.78245C20.0249 7.13531 19.6986 8.61326 19.0462 11.5692L18.2127 15.3455C17.9632 16.4759 17.8384 17.0412 17.4058 17.2532C16.9732 17.4652 16.4501 17.2175 15.4038 16.7221L12.6781 15.4314C12.0315 15.1253 11.7081 14.9722 11.3838 15.0367C11.0595 15.1013 10.8195 15.3665 10.3394 15.8969L10.0614 16.204C8.03007 18.4483 7.01439 19.5704 6.33069 19.2176C5.64698 18.8647 5.97319 17.3867 6.62562 14.4308L7.45914 10.6545Z"
      fill="currentColor"
    />
  </g>
  <defs>
    <clipPath id="clip0_148_5539">
      <rect width="25" height="25" fill="white" transform="translate(0 0.5)" />
    </clipPath>
  </defs>
</svg>
